export const BreakPointTest = () => (
  <div className="rounded bg-green-500 py-2 text-center text-xl font-bold sm:bg-yellow-500 md:bg-red-500 lg:bg-purple-600 xl:bg-black">
    <span className="block sm:hidden">&lt; sm</span>
    <span className="hidden sm:block md:hidden">sm</span>
    <span className="hidden md:block lg:hidden">md</span>
    <span className="hidden lg:block xl:hidden">lg</span>
    <span className="xxl:hidden hidden xl:block">xl</span>
  </div>
)
